import React from 'react';
import { TabContainer, TabItemContainer, TabItemText } from './TabSelector.styles';

export interface Tab<T = string> {
  value: T;
  label: string;
}

export interface TabSelectorProps<T = string> {
  tabs: Tab<T>[];
  activeTab: T;
  onTabChange: (tab: T) => void;
}

// Generic Tab Selector component
const TabSelector = <T extends string>({ tabs, activeTab, onTabChange }: TabSelectorProps<T>) => {
  return (
    <TabContainer>
      {tabs.map((tab) => (
        <TabItemContainer
          key={tab.value}
          $isActive={activeTab === tab.value}
          $tabCount={tabs.length}
          onClick={() => onTabChange(tab.value)}
        >
          <TabItemText $isActive={activeTab === tab.value}>{tab.label}</TabItemText>
        </TabItemContainer>
      ))}
    </TabContainer>
  );
};

export default TabSelector;
